<template>
    <div class="lesson">
        <div class="lesson-status">
            <el-tag size="small" v-for="item in screen" :key="item.value"
                :type="item.value === activeStatus ? 'default' : 'info'" @click="beforeChange(item.value)">{{item.text}}
            </el-tag>
        </div>
        <is-empty size="small" :show="data.length > 0" message="您还没有创建课堂~">
            <div class="lesson-list">
                <el-row class="lesson-item" v-for="lesson in data" :key="lesson.lessonId">
                    <el-col class="lesson-main" :span="20">
                        <el-row class="lesson-info">
                            <el-col class="lesson-pic" :span="7">
                                <el-image fit="cover" :src="lesson.avatar | filterUrl">
                                    <div class="image-placeholder" slot="placeholder">
                                        <i class="el-icon-loading"></i>
                                    </div>
                                    <div class="image-error" slot="error">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                </el-image>
                            </el-col>
                            <el-col :span="17">
                                <div class="lesson-title">{{ lesson.lessonName }}</div>
                                <p class="lesson-synopsis">
                                    <span>
                                        任课教师：
                                        <i>{{ lesson.teacher }}</i>
                                    </span>
                                </p>
                                <p class="lesson-summary">{{lesson.summary | ellipsis}}</p>
                                <div class="lesson-body">
                                    <span>
                                        创建时间：
                                        <i v-text="lesson.createTime"></i>
                                    </span>
                                    <span>
                                        邀请码：
                                        <i v-text="lesson.code"></i>
                                    </span>
                                    <span v-if="lesson.credits">
                                        <el-tag size="mini">
                                            {{`${lesson.credits?lesson.credits:0}学分`}}
                                        </el-tag>
                                    </span>
                                    <span v-if="lesson.periods">
                                        <el-tag size="mini">
                                            {{`${lesson.periods?lesson.periods:0}课时`}}
                                        </el-tag>
                                    </span>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col class="lesson-action" :span="4">
                        <div class="top">
                            <el-dropdown @command="handleClick($event, lesson.uid)" trigger="click">
                                <span class="el-dropdown-link">
                                    更多
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="edit">
                                        <i class="el-icon-edit"></i> 编辑
                                    </el-dropdown-item>
                                    <el-dropdown-item command="delete">
                                        <i class="el-icon-delete"></i> 删除
                                    </el-dropdown-item>
                                    <!-- <el-dropdown-item command="end">
                                        <i class="ultralab-icon-file-arrange"></i> 结课
                                    </el-dropdown-item> -->
                                    <!-- <el-dropdown-item>
                                        <i class="ultralab-icon-copy"></i> 复制课堂
                                    </el-dropdown-item> -->
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div class="bottom">
                            <el-button type="primary" size="small" @click="startLesson(lesson.uid)">开始上课</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </is-empty>
    </div>
</template>

<script>
import isEmpty from '@/components/common/is-empty'
export default {
    data () {
        return {
            activeStatus: '1',
            screen: [
                { value: '1', text: '上课中' },
                { value: '2', text: '已结课' }
            ]
        }
    },
    props: {
        data: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    components: {
        isEmpty
    },
    filters: {
        ellipsis(value) {
            if (!value) return "";
            if (value.length > 60) {
                return value.slice(0, 60) + "...";
            }
            return value;
        }
    },
    methods: {
        handleClick (op, uid) {
            this.$emit(op, uid)
        },
        beforeChange (val) {
            this.activeStatus = val
            this.$emit('status-change', val)
        },
		/**
		 *开始上课
		*/
        startLesson (uid) {
            this.$router.push(`/lesson/${uid}/type/exp`);
        }
    }
}
</script>
